<template>
	<div class="sa-list-component">
		<div class="sa-list-component-header">
			<b-form @submit.prevent="onSubmit">
				<date-filter-component ref="cmpDateFilterComponent"></date-filter-component>
				<b-row class="sa-form-btn-filter">
					<b-col class="sa-padding-right text-right">
						<b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
						<!-- <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button> -->
					</b-col>
				</b-row>
			</b-form>
		</div>
		<div class="sa-list-component-body">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
						size="sm"></b-pagination>
				</b-col>
			</b-row>
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="storicoItems"
					:fields="fieldStorico" :current-page="currentPage" :per-page="perPage" sort-icon-left
					head-variant="light" class="sa-b-table">
					<template #cell(soggetto)="row">
						<span>{{ row.item.cognomeRagioneSoggetto }} {{ row.item.nomeSoggetto }}</span>
					</template>
					<template #cell(documento)="row">
						<span
							style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{
								row.item.tipoDocumentoDescrizione }}</span>
						<span
							style="font-weight: 400; display: flex; width: 100%; justify-content: start; align-items: center">
							({{ row.item.numeroDocumento }}) </span>
						<span
							style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{
								getData(row.item.documentoData) }} </span>
					</template>

					<template #cell(tipoMovimento)="row"> {{
						getDescrizioneOperazioneContabile(row.item.causaleDocumentoOperazioneContabile) }} </template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
						size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import DateFilterComponent from "../../utility/components/DateFilterComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import ModalError from "../../../template/components/modal/components/ModalError.vue";

import moment from "moment";
export default {
	name: "MagazzinoArticoliStoricoContabileComponent",
	mixins: [UtilityMixin],
	props: {},
	components: { DateFilterComponent },

	mounted() {
		// let me = this;
	},
	data() {
		return {
			filtro: {
				idArticolo: null,
				codiceMagazzino: null,
			},
			currentPage: 1,
			perPage: 10,
			rows: 0,
			fieldStorico: [
				{
					label: "Documento",
					key: "documento",
					sortable: true,
				},
				{
					label: "Soggetto",
					key: "soggetto",
					sortable: true,
				},
				{
					label: "Qnt.",
					key: "quantita",
					sortable: true,
				},
				{
					label: "Prezzo Un.",
					key: "prezzoUnitario",
					sortable: true,
					formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
				},
				{
					label: "Totale Riga",
					key: "totaleRiga",
					sortable: true,
					formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
				},
				{
					label: "Totale Documento",
					key: "totaleDocumento",
					sortable: true,
					formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
				},
				{
					label: "Movimento",
					key: "tipoMovimento",
					sortable: true,
				},
			],
			jsonData: {},
			storicoItems: [],
			pathResouce: "/contabilitadocumentorighe/storicocontabilita",
		};
	},
	methods: {
		init(filtro) {
			if (filtro) {
				this.filtro = filtro;
			}
			this.loadStoricoContabilitaArticolo();
		},
		loadStoricoContabilitaArticolo() {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResouce, this.filtro, me.loadStoricoContabilitaArticoloSuccess, me.loadStoricoContabilitaArticoloError);
		},

		loadStoricoContabilitaArticoloSuccess(response) {
			let me = this;
			me.rows = response.data.data.recordsNumber;
			me.storicoItems = response.data.data.list;
		},
		loadStoricoContabilitaArticoloError(error) {
			console.log(error);
			this.$bvToast.toast("Attenzione", {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
		},
		getData(value) {
			return moment(new Date(value)).format("DD/MM/YYYY");
		},
		getDescrizioneOperazioneContabile(operazione) {
			if (operazione == 0) {
				return "INVARIATO";
			} else if (operazione > 0) {
				return "AVERE";
			} else if (operazione < 0) {
				return "DARE";
			}
		},
		onSubmit() {
			let dateFilter = this.$refs.cmpDateFilterComponent.getFilter();
			this.filtro.dataDal = dateFilter.dataDal;
			this.filtro.dataAl = dateFilter.dataAl;
			this.loadStoricoContabilitaArticolo();
		},
		onReset() { },
	},
};
</script>
